import React from 'react';

import { StyledNewsMiniature } from './NewsMiniature.styles';

import { NewsMiniatureProps } from './NewsMiniature.types';

const NewsMiniature = ({
  url,
  seeMore,
  renderLink,
  componentClassname = 'news-miniature',
  customClassnames = '',
  customStyle = '',
  ...props
}: NewsMiniatureProps) => {
  return (
    <StyledNewsMiniature
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      {renderLink ? (
        renderLink({
          href: url,
          children: seeMore,
          target: '_blank',
          rel: 'noreferrer',
          additionalParams: {
            className: `${componentClassname}__article-link`,
          },
        })
      ) : (
        <a
          className={`${componentClassname}__article-link`}
          href={url}
          target="_blank"
          rel="noreferrer"
        >
          {seeMore}
        </a>
      )}
    </StyledNewsMiniature>
  );
};
NewsMiniature.displayName = 'NewsMiniature';

export default NewsMiniature;
